import React from "react";
import {
  Datagrid,
  List, NumberInput,
  ImageField,
  ImageInput,
  SimpleShowLayout,
  TextField,
  UrlField,
  ReferenceField,
  TextInput,
  ArrayField,
  SimpleFormIterator,
  ArrayInput,
  ReferenceInput,
  DateField,
  SelectInput,
  Filter,
} from "react-admin";
import EditView from "../../components/EditView";
import CreateView from "../../components/CreateView";
import ShowView from "../../components/ShowView";
import Emoji from '../../components/Emoji'
import {Symptoms, SymptomsFilter} from '../../constants/choices'

const PlanFilter = (props) => (
  <Filter {...props}>
    <SelectInput
      label="Symptoms"
      choices={SymptomsFilter().sort((a, b) => a.name.localeCompare(b.name))}
      optionText={"name"}
      optionValue={"value"}
      source={"symptoms"}
      alwaysOn
    />
  </Filter>
);

export const PlanList = (props) => (
  <List {...props} filters={<PlanFilter/>}>
    <Datagrid rowClick="show">
      <TextField source="objectId"/>
      <ImageField source="icon"/>
      <TextField source="title"/>
      <TextField source="duration" label="Duration (days)"/>
      <ArrayField label="Symptoms" source="adminSymptoms">
        <Datagrid>
          <TextField label="Symptom" source="symptoms" />
        </Datagrid>
      </ArrayField>
      <ReferenceField link="show" label="Previous plan" source="parentId" reference="plan" >
        <TextField source="title"/>
      </ReferenceField>
      <DateField showTime={true} source="createdAt"/>
      <DateField showTime={true} source="updatedAt"/>
    </Datagrid>
  </List>
);

export const PlanEdit = (props) => (
  <EditView {...props}>
    <ReferenceInput label="Previous plan" source="parentId" reference="plan">
      <SelectInput optionText="title" alwaysOn/>
    </ReferenceInput>
    <TextInput source="title"/>
    <TextInput source="title_fr" />
    <TextInput source="title_de" />
    <TextInput source="title_nl" />
    <TextInput source="title_es" />
    <TextInput source="title_pt" />
    <Emoji source="description" label="Description" />
    <Emoji label="Description FR" source="description_fr" />
    <Emoji label="Description DE" source="description_de" />
    <Emoji label="Description NL" source="description_nl" />
    <Emoji label="Description ES" source="description_es" />
    <Emoji label="Description PT" source="description_pt" />
    <Emoji source="shortDescription" label="Short description" />
    <Emoji label="shortDescription FR" source="shortDescription_fr" />
    <Emoji label="shortDescription DE" source="shortDescription_de" />
    <Emoji label="shortDescription NL" source="shortDescription_nl" />
    <Emoji label="shortDescription ES" source="shortDescription_es" />
    <Emoji label="shortDescription PT" source="shortDescription_pt" />
    <NumberInput source="duration" label="Duration (days)"/>
    <ArrayInput label="Symptoms" source="adminSymptoms">
      <SimpleFormIterator>
        <SelectInput source="symptoms" choices={Symptoms} />
      </SimpleFormIterator>
    </ArrayInput>
    <TextInput source="icon"/>
    <ImageInput source="pictures" label="Image" accept="image/*">
      <ImageField source="src" title="imageUrl"/>
    </ImageInput>
    <TextInput source="referenceUrl"/>
  </EditView>
);

export const PlanShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <ReferenceField link="show" label="Previous plan" source="parentId" reference="plan" >
        <TextField source="title"/>
      </ReferenceField>
      <TextField source="objectId"/>
      <TextField source="title"/>
      <TextField source="title_fr"/>
      <TextField source="title_de"/>
      <TextField source="title_nl"/>
      <TextField source="title_es"/>
      <TextField source="title_pt"/>
      <TextField source="description"/>
      <TextField source="description_fr"/>
      <TextField source="description_de"/>
      <TextField source="description_nl"/>
      <TextField source="description_es"/>
      <TextField source="description_pt"/>
      <TextField source="shortDescription"/>
      <TextField source="shortDescription_fr"/>
      <TextField source="shortDescription_de"/>
      <TextField source="shortDescription_nl"/>
      <TextField source="shortDescription_es"/>
      <TextField source="shortDescription_pt"/>
      <TextField source="duration" label="Duration (days)"/>
      <ArrayField label="Symptoms" source="adminSymptoms">
        <Datagrid>
          <TextField label="Symptom" source="symptoms" />
        </Datagrid>
      </ArrayField>
      <ImageField source="icon"/>
      <UrlField source="referenceUrl"/>
      <DateField showTime={true} source="createdAt"/>
      <DateField showTime={true} source="updatedAt"/>
    </SimpleShowLayout>
  </ShowView>
);

export const PlanCreate = (props) => (
  <CreateView {...props}>
    <ReferenceInput label="Previous plan" source="parentId" reference="plan">
      <SelectInput optionText="title"  alwaysOn/>
    </ReferenceInput>
    <TextInput source="title"/>
    <TextInput source="title_fr" />
    <TextInput source="title_de" />
    <TextInput source="title_nl" />
    <TextInput source="title_es" />
    <TextInput source="title_pt" />
    <NumberInput label="Duration (days)" source="duration"/>
    <Emoji source="description" label="Description" />
    <Emoji source="description_fr" label="Description FR" />
    <Emoji source="description_de" label="Description DE" />
    <Emoji source="description_nl" label="Description NL" />
    <Emoji source="description_es" label="Description ES" />
    <Emoji source="description_pt" label="Description PT" />
    <Emoji source="shortDescription" label="Short description" />
    <Emoji source="shortDescription_fr" label="Short description FR" />
    <Emoji source="shortDescription_de" label="Short description DE" />
    <Emoji source="shortDescription_nl" label="Short description NL" />
    <Emoji source="shortDescription_es" label="Short description ES" />
    <Emoji source="shortDescription_pt" label="Short description PT" />
    <ArrayInput label="Symptoms" source="adminSymptoms">
      <SimpleFormIterator>
        <SelectInput label="Symptom" source="symptoms" choices={Symptoms} />
      </SimpleFormIterator>
    </ArrayInput>
    <ImageInput source="pictures" label="Image" accept="image/*">
      <ImageField source="src" title="imageUrl"/>
    </ImageInput>
    <TextInput source="referenceUrl"/>
  </CreateView>
);
